<template>

  <div class="container-fluid" v-if="permissao && !loading">

    <div class="box box-info">
      <div class="box-header with-border">
        <h2>Fechamento Extracontratual</h2>
      </div>
      <div v-if="janelaAplicacao < 0">
        <h4 class="text-center">Não estamos no período de aplicação do Extracontratual</h4>
        <h5 class="text-center"><b>Janela de aplicação:</b> do dia 21 ao 2° dia útil do mês seguinte</h5>
        <br>
      </div>
      <div v-else>
        <!-- form start -->
        <form class="form-horizontal">
          <h4 class="box-title text-center">Selecione os dados do contrato</h4>
          <div class="box-body">

            <div class="row">
              <!-- Select Estate -->
              <div class="form-group col-xs-12 col-sm-4 col-md-6">
                <label for="inputEmail3" class="col-sm-6 control-label">Estado:</label>
                <div class="col-sm-5">
                  <select class="form-control" v-model="uf_selecionada">
                    <option v-for="uf in ufs" :value='uf' :key="uf.id">{{ uf.nome }}</option>
                  </select>
                </div>
              </div>

              <!-- Select Month -->
              <div class="form-group col-xs-12 col-sm-4 col-md-6">
                <label for="inputPassword3" class="col-sm-2 control-label">Mês:</label>
                <div class="col-sm-5">
                  <select class="form-control" v-model="mesSelecionado" disabled>
                    <option v-for="mes in meses" :value="mes" :key="mes.id">{{ mes.nome }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Select Contract -->
              <div class="form-group col-xs-12 col-sm-4 col-md-6">
                <label for="inputEmail3" class="col-sm-6 control-label">Contrato:</label>
                <div class="col-sm-5">
                  <select class="form-control" v-model="contrato_selecionado">
                    <option v-for="i in tipo_imovel_servicos" :value='i' :key="i.id">{{ i.nome }}</option>
                  </select>
                </div>
              </div>

              <!-- Select Year -->
              <div class="form-group col-xs-12 col-sm-4 col-md-6">
                <label for="inputPassword3" class="col-sm-2 control-label">Ano:</label>
                <div class="col-sm-5">
                  <select class="form-control" v-model="ano_selecionado" disabled>
                    <option v-for="i in anos" :key="i.id">{{ i.ano }}</option>
                  </select>
                </div>
              </div>
            </div>

          </div>

          <div class="box-footer">
            <b-button variant="primary" v-if="verificaCamposPrenchidos" @click="exibeModalFechamento()">Continuar
            </b-button>

            <b-button variant="primary" v-else disabled>Aguardando preenchimento dos campos
            </b-button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      anos: [],
      ano_selecionado: new Date().getFullYear(),
      uf_selecionada: null,
      contrato_selecionado: null,
      mes: [],
      meses: [],
      tipo_imovel_servicos: '',
      env: process.env,
      estado: this.$store.state.login.loginUsuario.estado,
      ufs: [],
      ufId: [],
      gruposPermitidos: ['oi', 'admin'],
      permissao: true,
      loading: true,
      dadosFechamento: [],
      mesSelecionado: null,
      janelaAplicacao: null
    }
  },
  mounted: function () {
    // Array com grupos do usuário
    let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
    // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
    let msgGrupos = usuarioGrupo[0].nome
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome
      }
    }
    // console.log(msgGrupos)
    // if (this.usuarioGrupo.includes('admin') === true || this.usuarioGrupo.includes('oi') === true) {
    if (usuarioGrupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin')) {
      // this.getMes()
      this.getAno()
      this.getTipoImovelServico()
      this.getUfsUsuario()
      this.getIdUfsUsuario()
      this.getContratosPorUf()
    } else {
      this.permissao = false
      this.$store.commit('setPermissaoNegada', { msg: `Seu grupo de usuáro [ ${msgGrupos} ] não permisse acesso a esta área.`, status: false, show: true })
    }
    this.getJanelaAplicacao()
  },
  watch: {
    mesSelecionado: function () {
      this.mes_atual = this.mesSelecionado
    }
  },
  computed: {
    verificaCamposPrenchidos: function () {
      if (this.contrato_selecionado !== null &&
        this.mesSelecionado !== null &&
        this.uf_selecionada !== null) {
        return 1
      }
      return 0
    }
  },
  methods: {
    exibeModalFechamento: async function () {
      this.dadosFechamento = []
      await this.dadosFechamento.push({
        'uf_selecionada': this.uf_selecionada.nome,
        'mesSelecionado': this.mesSelecionado.nome,
        'ano_selecionado': this.ano_selecionado,
        'contrato_selecionado': this.contrato_selecionado.nome,
        'id_contrato': this.contrato_selecionado.id,
        'uf_id': this.uf_selecionada.id,
        'mes_id': this.mesSelecionado.id
      })

      await this.$store.commit('setDadosFechamento', this.dadosFechamento[0])
      this.$store.commit('setExtraContratual', { conteudo: null, show: true })
    },
    // preencherFechamento: function () {
    //   this.dadosFechamento = []
    //   this.dadosFechamento.push({
    //     'uf_selecionada': this.uf_selecionada.nome,
    //     'mesSelecionado': this.mesSelecionado.nome,
    //     'ano_selecionado': this.ano_selecionado,
    //     'contrato_selecionado': this.contrato_selecionado.nome,
    //     'id_contrato': this.contrato_selecionado.id,
    //     'uf_id': this.uf_selecionada.id,
    //     'mes_id': this.mesSelecionado.id
    //   })
    //   this.$store.commit('setDadosFechamento', this.dadosFechamento[0])
    // },
    getItemSla() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getitenssla/${vm.contrato.tipo_contrato_id}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.itens_sla = response.data
      })
    },
    getTipoImovelServico() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/gettipoimovelservico`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.tipo_imovel_servicos = response.data
        })
    },
    getMes() {
      let date = new Date()
      this.mes_atual = date.getMonth()
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getmes`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.meses = response.data
        vm.mesSelecionado = vm.meses.find(el => el.id == vm.janelaAplicacao)
      })
    },
    getAno() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getano`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.anos = response.data
        })
    },
    getContratosPorUf() {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getcontratosporuf`, vm.ufs, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          vm.contratos = response.data
        })
    },
    getUfsUsuario() {
      this.ufs = this.$store.state.login.loginUsuario.estado
    },
    getIdUfsUsuario() {
      this.ufId = this.$store.state.login.loginUsuario.estado
    },
    getJanelaAplicacao() {
      let vm = this
      vm.$axios.get(`${vm.env.FINANCEIRO.SLA}/getJanelaAplicacaoExtraContratual`, {
        headers: {
          'Authorization': `Bearer ${vm.$store.state.login.loginUsuario.token}`
        }
      })
        .then(function (response) {
          // vm.janelaAplicacao = -1
          vm.janelaAplicacao = response.data
          vm.getMes()
          vm.loading = false
        })
        .catch(function (error) {
          vm.loading = true
          vm.$store.commit('setAlert', { msg: 'Falha ao tentar carregar a janela de aplicação do ExtraContratual', status: false, show: true })
        })
    }
  }
}
</script>

<style scoped>
.box-title,
.control-label {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ListarFechamentoExtra.vue?c15ad656